module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pomodoro_bar.322d5833.svg";